export default __webpack_public_path__ + "static/asystent_cukrzyca_logo-685630f6adbdb69f064214ef0a982e11.svg";